import { createContext } from 'react';

import RootStore from './Store';

const RootStoreContext = createContext<RootStore | undefined>(undefined);

export default RootStoreContext;
